import { render, staticRenderFns } from "./GoodsGroup.vue?vue&type=template&id=d977557a&"
import script from "./GoodsGroup.vue?vue&type=script&lang=js&"
export * from "./GoodsGroup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports